define('MultiAddToCart.DynamicCSS', [
    'jQuery',
    'underscore'
], function MultiAddToCartDynamicCSS(
    jQuery
) {
    'use strict';

    return {
        addStylesToPage: function addStylesToPage(cssContent) {
            var $style = jQuery('head').find('#custom-additional-styles');

            if (!$style.length) {
                $style = jQuery('head')
                    .append('<style type="text/css" id="custom-additional-styles"></style>')
                    .find('#custom-additional-styles');
            }

            $style.html(cssContent);
        },

        applyDynamicCSS: function applyDynamicCSS(category, isDiagramCategory) {
            var stylesContent = [];

            if (category && category.internalid) {
                stylesContent.push('.part-number-category-' + category.internalid + ' { display: block!important; }');
            }

            if (isDiagramCategory) {
                stylesContent.push('.facets-facet-browse-list-header-actions { display: none!important; }');
            }

            this.addStylesToPage(stylesContent.join('\n'));
        }
    };
});
